export default __webpack_public_path__ + "367783878b57d42e3c2525b73cbeca54.png";